import Image from "next/image";
import { IMediaInput } from "@types";
import { useImageVariants } from "./imageUtils";
import React from "react";

interface ImagePrepareProps {
  media?: IMediaInput;
  alt: string;
  width?: number;
  priority?: boolean;
  sizes?: string;
  fetchPriority?: "high" | "auto" | "low";
}

const ImagePrepare: React.FC<ImagePrepareProps> = ({ media, alt, width, priority = false, fetchPriority = "auto", sizes = "100vw" }) => {
  const { webpImage, image } = useImageVariants(media, width);
  let imageComponent;

  if (webpImage) {
    imageComponent = <Image src={webpImage.url} fill alt={alt} className="object-cover w-full h-full" sizes={sizes} priority={priority} fetchPriority={fetchPriority} />;
  } else if (image) {
    imageComponent = <Image src={image.url} fill alt={alt} className="object-cover w-full h-full" sizes={sizes} priority={priority} fetchPriority={fetchPriority} />;
  } else {
    imageComponent = <Image src={media?.url || '/imgs/placeholder.webp'} placeholder={media?.blur_data_url ? "blur" : "empty"} fill alt={alt} className="object-cover w-full h-full" sizes={sizes} priority={priority} fetchPriority={fetchPriority} blurDataURL={media?.blur_data_url} />;
  }

  return (
    <div className="w-full h-full relative">
      {imageComponent}
    </div>
  );
}

export default ImagePrepare;
